import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import AddAlert from "@material-ui/icons/AddAlert";
//core components
import Snackbar from "components/Snackbar/Snackbar.js";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
// core components
import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import { saveSession } from '../../utils/sessionUtils';
import loginPageStyle from "assets/jss/material-dashboard-react/views/loginPage.jsx";
import background from "assets/img/fondo.jpg";

require("dotenv").config();

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      email: "",
      pass: "",
      open: false,
      place: "",
      color: "",
      message: ""
    };
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  getYear() {
    return new Date().getFullYear();
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  sendSnackbar(mess) {
    this.setState({ open: true, message: mess, place: "br", color: "danger" });
    let that = this;
    setTimeout(function() {
      that.setState({ open: false });
    }, 6000);
  }
  setOpen(op) {
    this.setState({ open: op });
  }

  handleSubmit(event) {
    event.preventDefault();
    let that = this;
    let { email, pass } = this.state;

    // BUG-L2: Validar campos vacíos
    if (!email || email.trim() === "") {
      that.sendSnackbar("El usuario es requerido");
      return;
    }
    if (!pass || pass.trim() === "") {
      that.sendSnackbar("La contraseña es requerida");
      return;
    }

    let header = {
      method: "POST",
      body: JSON.stringify({ Clave: pass, Usuario: email }),
      headers: { "Content-Type": "application/json" }
    };
    fetch(process.env.REACT_APP_URL_API + "logeo", header)
      .then(res => res.json())
      .then(result => {
        if (result.Ok) {
          if (result.result[0][0].sResultado === 1) {
            const userData = {
              email,
              userId: result.result[0][0].sIdUsuario,
              user: result.result[0][0].sUsuario,
              rol: result.result[0][0].sRol,
              menu: result.result[0][0].sMenu
            };
            if (result.token) {
              // Decode JWT payload (base64url → base64 → decode)
              const base64 = result.token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
              const payload = JSON.parse(atob(base64));
              saveSession(result.token, userData, payload.exp * 1000);
            } else {
              // Fallback: guardar sesión sin JWT (compatibilidad)
              const expiration = Date.now() + (8 * 60 * 60 * 1000);
              saveSession('legacy', userData, expiration);
            }
            that.setState({ email: "" });
          } else {
            that.sendSnackbar(result.result[0][0].sMensaje);
          }
        }
      })
      .catch(() => {
        that.sendSnackbar("Error de conexión con el servidor");
      });
  }

  render() {
    const { classes, ...rest } = this.props;
    if (localStorage.getItem("user") !== null) {
      return <Redirect to="/" />;
    }
    return (
      <div>
        <Header absolute color="transparent" brand="Proyecto" {...rest} />
        <div
          className={classes.pageHeader}
          style={{
            backgroundColor: "grey",
            backgroundSize: "cover",
            backgroundPosition: "top center",
            backgroundImage: `url(${background})`
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={4} lg={4}>
                <Card className={classes[this.state.cardAnimaton]}>
                  <form
                    onSubmit={e => {
                      this.handleSubmit(e);
                    }}
                    className={classes.form}
                  >
                    <CardHeader color="primary" className={classes.cardHeader}>
                      <h4>Iniciar sesión</h4>
                    </CardHeader>
                    <CardBody>
                      <CustomInput
                        labelText="Usuario"
                        id="email"
                        onChange={e => {
                          this.handleChange(e);
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Email className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                          maxLength: 50
                        }}
                      />
                      <CustomInput
                        labelText="Contraseña"
                        id="pass"
                        formControlProps={{
                          fullWidth: true
                        }}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                        inputProps={{
                          type: "password",
                          endAdornment: (
                            <InputAdornment position="end">
                              <Icon className={classes.inputIconsColor}>
                                lock_outline
                              </Icon>
                            </InputAdornment>
                          ),
                          autoComplete: "off",
                          maxLength: 255
                        }}
                      />
                      <div style={{ textAlign: "end" }}>
                        <Button color="primary" type="submit" round>
                          Iniciar sesión
                        </Button>
                      </div>
                    </CardBody>
                    <CardFooter className={classes.cardFooter}>
                      <p>© Wiiba {this.getYear()}</p>
                    </CardFooter>
                  </form>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
          <Snackbar
            place={this.state.place}
            color={this.state.color}
            icon={AddAlert}
            message={this.state.message}
            open={this.state.open}
            closeNotification={() => this.setOpen(false)}
            close
          />
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object
};

export default withStyles(loginPageStyle)(LoginPage);
